import { render, staticRenderFns } from "./NavigationFooter.vue?vue&type=template&id=6baa3082&"
import script from "./NavigationFooter.vue?vue&type=script&lang=ts&"
export * from "./NavigationFooter.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationFooter.vue?vue&type=style&index=0&id=6baa3082&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports